// src/redux/slices/tpnConfigSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TpnConfig } from '../../types/tpnConfig';

interface TpnConfigState {
  data: TpnConfig | null;
  loading: boolean;
  error: string | null;
}

const initialState: TpnConfigState = {
  data: null,
  loading: false,
  error: null,
};

export const tpnConfigSlice = createSlice({
  name: 'tpnConfig',
  initialState,
  reducers: {
    // Fetch TPN config actions
    fetchTpnConfigRequest: state => {
      state.loading = true;
      state.error = null;
    },
    fetchTpnConfigSuccess: (state, action: PayloadAction<TpnConfig>) => {
      state.loading = false;
      state.data = action.payload;
      state.error = null;
    },
    fetchTpnConfigFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
      state.data = null;
    },
  },
});

export const {
  fetchTpnConfigRequest,
  fetchTpnConfigSuccess,
  fetchTpnConfigFailure,
} = tpnConfigSlice.actions;

export default tpnConfigSlice.reducer;
